<template>
  <div class="AddNewWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back"
                leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewWidget-main lxn-pos-rel">
      <div class="AddNewWidget-main-wrapper lxn-margin-auto lxn-border-round">

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_folder }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <FolderWidget :index="-1">
              </FolderWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_folderDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addFolderWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_singleSwitch }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <div class="AddNewWidget-wrapper-switch lxn-margin-auto">
                <SingleSwitch state="on" bgColorOn="#00AEEF" bgColorOff="#FFFFFF" bgColorPending="#CCCCCC"
                              handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
              </div>
              <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text"
                   :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                {{ $store.getters.language.texts.RelaySSR2ASettings_switchState_On }}
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_singleSwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addSingleSwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_singleThreeWaySwitch }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                <SingleThreeWaySwitch state="off" widgeetMode="auto" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                      bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
              </div>
              <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text"
                   :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto }} -
                {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off }}
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_singleSwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/AddSingleThreewaySwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>
        <!-- 3 way switch -->
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_autoThreeWaySwitch }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100 row align-items-center">
              <div class="light-icon active" :class="$store.getters.language.floatClassReverse">
                <ButtonIcon :size="40" bgColor="#ECECEC" :icon="'lamp'" iconColor="#53636C" :padding="8"/>
              </div>
              <div class="col-8">
                <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text"
                     :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                  {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On }} -
                  {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_autoThreeWaySwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/AddAutoThreewaySwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>


        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_autoThreeWaySwitch }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                <SingleThreeWaySwitch state="off" widgeetMode="auto" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                      bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
              </div>
              <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text"
                   :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto }} -
                {{ this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off }}
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_autoThreeWaySwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/AddAutoThreewaySwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>


        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNode14_title }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                <SingleSwitch state="on" bgColorOn="#00AEEF" bgColorOff="#FFFFFF" bgColorPending="#CCCCCC"
                              handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
              </div>
              <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text"
                   :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                {{ $store.getters.language.texts.RelaySSR2ASettings_switchState_On }}
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_singleSwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/AddS1TouchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>


        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNode13_title }}
          </div>
          <div class="halfHeight" style="background-color: #ECECEC;">
            <div class="lxn-w100 lxn-h100">
              <div class="AutoThreewaySwitchWidget-output-wrapper">
                <div class="lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
                  <div class="halfHeight">
                    <div class="lxn-w100 lxn-h100 row align-items-center">

                      <div class="lxn-w100 lxn-h100">
                        <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                          <SingleThreeWaySwitch :state="'on'" :widgeetMode="'auto'" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                                bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
                        </div>
                        <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="'color: #9B59B6'"
                             :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                          {{ $store.getters.language.texts.RelaySSR2ASettings_switchState_Auto }}
                        </div>
                      </div>
                    </div>
                    <div class="lxn-w100 lxn-h100 row align-items-center">
                      <div class="lxn-w100 lxn-h100">
                        <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                          <SingleThreeWaySwitch :state="'off'" :widgeetMode="''" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                                bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
                        </div>
                        <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="'color: #FF4D4D'"
                             :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                          {{ $store.getters.language.texts.RelaySSR2ASettings_switchState_Off }}
                        </div>
                      </div>
                    </div>
                    <div class="lxn-w100 lxn-h100 row align-items-center">
                      <div class="lxn-w100 lxn-h100">
                        <div class="AddNewWidget-wrapper-threeway-switch lxn-margin-auto">
                          <SingleThreeWaySwitch :state="'on'" :widgeetMode="''" bgColorOn="#00AEEF" bgColorOff="#ACB8BF"
                                                bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF"/>
                        </div>
                        <div class="AddNewWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="'color: #00AEEF'"
                             :class="[$store.getters.language.font, $store.getters.language.directionClass]">
                          {{ $store.getters.language.texts.RelaySSR2ASettings_switchState_On }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_AutoThreewaySwitchWidgetDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/AddAutoThreewaySwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_doubleSwitch }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <DoubleSwitchWidget :index="-1">
              </DoubleSwitchWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_doubleSwitchDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addDoubleSwitchWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_sceneButton }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <SceneButtonWidget :index="-1">
              </SceneButtonWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_sceneButtonDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addSceneButtonWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_temperatureAutomation }}
          </div>
          <div class="AddNewWidget-widget-body">
            <div class="lxn-w100 lxn-h100">
              <TemperatureAutomationWidget :index="-1">
              </TemperatureAutomationWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_temperatureAutomationDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addTemperatureAutomationWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_RGBW }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <RGBWWidget :index="-1">
              </RGBWWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_rgbwDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addRGBWWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_SmartCurtain }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <SmartCurtainWidget :index="-1">
              </SmartCurtainWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_smartCurtainDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addSmartCurtainWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_acRemote }}
          </div>
          <div class="AddNewWidget-widget-body">
            <div class="lxn-w100 lxn-h100">
              <AcRemoteWidget :index="-1">
              </AcRemoteWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_acRemoteDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addAcRemoteWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_tvRemote }}
          </div>
          <div class="AddNewWidget-widget-body">
            <div class="lxn-w100 lxn-h100">
              <TvRemoteWidget :index="-1">
              </TvRemoteWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_tvRemoteDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addTvRemoteWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>

        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_temperatureWidget }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <TemperatureWidget :index="-1">
              </TemperatureWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_temperatureWidgetDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addTemperatureWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
        <hr/>
        <div class="AddNewWidget-widget lxn-border-round lxn-h100 lxn-overflow-hidden lxn-margin-auto">
          <div class="AddNewWidget-widget-header lxn-text lxn-text lxn-text-center"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.LuxinWidget_humidityWidget }}
          </div>
          <div class="AddNewWidget-widget-body halfHeight">
            <div class="lxn-w100 lxn-h100">
              <HumidityWidget :index="-1">
              </HumidityWidget>
            </div>
          </div>
        </div>
        <div class="AddNewWidget-wrapper-description lxn-w100">
          <div class="AddNewWidget-description lxn-w100 lxn-text"
               :class="[$store.getters.language.font, $store.getters.language.directionClass]">
            {{ $store.getters.language.texts.AddNewWidget_humidityWidgetDescription }}
          </div>
          <div class="AddNewWidget-description-button lxn-w100">
            <CustomButton @click="$router.push('/addHumidityWidget')" bgColor="#1EA5DE" iconRight="plus"
                          iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8"
                          :useLanguageDirection="true">
              {{ $store.getters.language.texts.AddNewWidget_button }}
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import SingleSwitch from '@/components/SingleSwitch.vue'
import SingleThreewaySwitch from '@/components/SingleThreewaySwitch.vue'
import AutoThreewaySwitch from '@/components/AutoThreewaySwitch.vue'
import TopNav from '@/components/TopNav.vue'
import AcRemoteWidget from '@/components/widgets/AcRemoteWidget.vue'
import DoubleSwitchWidget from '@/components/widgets/DoubleSwitchWidget.vue'
import FolderWidget from '@/components/widgets/FolderWidget.vue'
import HumidityWidget from '@/components/widgets/HumidityWidget.vue'
import RGBWWidget from '@/components/widgets/RGBWWidget.vue'
import SceneButtonWidget from '@/components/widgets/SceneButtonWidget.vue'
import SmartCurtainWidget from '@/components/widgets/SmartCurtainWidget.vue'
import TemperatureAutomationWidget from '@/components/widgets/TemperatureAutomationWidget.vue'
import TemperatureWidget from '@/components/widgets/TemperatureWidget.vue'
import TvRemoteWidget from '@/components/widgets/TvRemoteWidget.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import AutoManualSwitchWidget from "@/components/widgets/AutoManualSwitchWidget";


export default {
  name: 'AddNewWidget',
  components: {
    AutoManualSwitchWidget,
    CustomCurve,
    TopNav,
    AutoThreewaySwitch: AutoThreewaySwitch,
    SingleSwitch,
    DoubleSwitchWidget,
    CustomButton,
    ButtonIcon,
    SceneButtonWidget,
    TemperatureAutomationWidget,
    RGBWWidget,
    SmartCurtainWidget,
    AcRemoteWidget,
    TemperatureWidget,
    HumidityWidget,
    TvRemoteWidget,
    FolderWidget,
    SingleThreeWaySwitch: SingleThreewaySwitch,
    // S1TouchWidget
  },
  data: function () {
    return {}
  },
  mounted: function () {
  },
  watch: {},
  computed: {
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
.AddNewWidget-topCurve-wrapper {
  height: 200px;
}

.AddNewWidget-main {
  z-index: 2;
}

.AddNewWidget-main-wrapper {
  width: calc(100% - 36px);
  margin-top: -150px;
  z-index: 2;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}

.AddNewWidget-wrapper-description {
  margin-top: 14px;
  margin-bottom: 14px;
}

.AddNewWidget-widget {
  width: calc(50% - 5px);
}

.AddNewWidget-widget-header {
  height: 30px;
  background-color: #DEDEDE;
  line-height: 30px;
}

.AddNewWidget-widget-body {
  height: 180px;
  background-color: #ECECEC;
}

.AddNewWidget-widget-body.halfHeight {
  height: 70px;
  background-color: #ECECEC;
}

.AddNewWidget-wrapper-switch {
  height: 40px;
  width: 38%;
  padding-top: 10px;
  margin: auto;
}

.AddNewWidget-wrapper-switch .SingleSwitchGeneral {
  width: 100%;
}

.AddNewWidget-wrapper-threeway-switch {
  height: 40px;
  width: 60%;
  margin: auto;
  padding-top: 8px;
}

.AddNewWidget-wrapper-text {
  height: 30px;
  line-height: 30px;
  color: #00AEEF;
}

.AddNewWidget-description-button {
  height: 50px;
}

.AddNewWidget-description {
  line-height: 20px;
  margin-bottom: 14px;
}
.align-items-center{
  align-items:center;
}
</style>
